import React, { useState } from 'react';
import { Gift, TrendingDown, AlertTriangle, HandCoins } from 'lucide-react';
import BonusAllowances from './BonusAllowances';
import LossDamages from './LossDamages';
import Recoveries from './Recoveries';
import LoansAdvances from './LoansAdvances';

const TABS = [
  { id: 'bonus-allowances', label: 'Bonus & Allowances', icon: Gift,           component: BonusAllowances },
  { id: 'loss-damages',     label: 'Loss & Damages',     icon: TrendingDown,   component: LossDamages },
  { id: 'recoveries',       label: 'Recoveries',         icon: AlertTriangle,  component: Recoveries },
  { id: 'loans-advances',   label: 'Loans & Advances',   icon: HandCoins,      component: LoansAdvances },
];

export default function Adjustments() {
  const [activeTab, setActiveTab] = useState('bonus-allowances');
  const active = TABS.find(t => t.id === activeTab);
  const ActiveComponent = active?.component;

  return (
    <div style={{ padding: '1.5rem 2rem' }}>
      {/* Tab bar */}
      <div style={{
        display: 'flex', gap: '0.5rem', flexWrap: 'wrap',
        marginBottom: '1.5rem',
        background: 'var(--theme-surface, #fdf9f3)',
        border: '1px solid var(--theme-border, #e5e7eb)',
        borderRadius: '0.75rem',
        padding: '0.35rem',
      }}>
        {TABS.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: '0.45rem',
                padding: '0.55rem 1rem',
                fontSize: '0.85rem', fontWeight: isActive ? '600' : '500',
                color: isActive ? '#fff' : 'var(--theme-textSecondary, #6b7280)',
                background: isActive
                  ? 'linear-gradient(135deg, var(--theme-primary, #6366f1), var(--theme-primaryDark, #4f46e5))'
                  : 'transparent',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
                boxShadow: isActive ? '0 2px 6px rgba(99,102,241,0.3)' : 'none',
                flex: '1 1 auto',
                justifyContent: 'center',
                whiteSpace: 'nowrap',
              }}
              onMouseEnter={e => {
                if (!isActive) {
                  e.currentTarget.style.background = 'var(--theme-surfaceHover, #f0ebe0)';
                  e.currentTarget.style.color = 'var(--theme-text, #111827)';
                }
              }}
              onMouseLeave={e => {
                if (!isActive) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = 'var(--theme-textSecondary, #6b7280)';
                }
              }}
            >
              <Icon size={15} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Active form */}
      {ActiveComponent && <ActiveComponent />}
    </div>
  );
}
